/*@ngInject*/
const ComponentSettingsController = function ($scope, $element, $stateParams, $uibModal, $q, xmlUtil, localization, dataSetType, componentSettingsMediator, inputType, displayConditionOperator, formViewerModel, configurationConstant, formTemplateStatus, fieldTemplateComponentSettingOwningClass, formMediator, componentSettingsUtil, componentSettingsConstant, authorizationConstants, currentUserModel, coreMediator, configurationMediator, modalUtil, displayConditionLogicalOperator) {

    $element.addClass('componentSettings');

    this.isLoading = true;

    localization.getTranslationByKey('componentSettings').then((translations) => {
        this.init = function (uiField) {
            const isUnsavedComponent = typeof uiField.fieldTemplate.id === 'string';

            this.isLoading = true;

            this.fieldReferenceCount = 0;
            this.fieldReferenceText = '';

            this.settings = {};
            this.displayConditionsSettings = {};
            this.settingsNeedingDataSets = {};
            this.owningClassPropertyNameMap = {};
            this.owningClassPropertyNameMap[fieldTemplateComponentSettingOwningClass.FIELD_TEMPLATE] = {};
            this.owningClassPropertyNameMap[fieldTemplateComponentSettingOwningClass.UI_FIELD] = {};

            this.coreSettings = [];
            this.displaySettings = [];
            this.editabilitySettings = [];
            this.visibilitySettings = [];
            this.requiredSettings = [];
            this.valueSettings = [];
            this.validationSettings = [];
            this.componentSpecificSettings = [];

            this.showCoreSettings = false;
            this.showDisplaySettings = false;
            this.showEditabilitySettings = false;
            this.showVisibilitySettings = false;
            this.showRequiredSettings = false;
            this.showValueSettings = false;
            this.showValidationSettings = false;
            this.showComponentSpecificSettings = false;

            this.userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

            if (!isUnsavedComponent) {
                formMediator.findReferenceCountByFieldTemplateId(uiField.fieldTemplate.id).then((count) => {
                    this.fieldReferenceCount = count;
                    if (this.fieldReferenceCount !== 0) {
                        this.fieldReferenceText = _.get(translations, 'fieldReferences');
                        this.fieldReferenceText = _.replace(this.fieldReferenceText, '{0}', this.fieldReferenceCount);
                        if (this.fieldReferenceCount === 1) {
                            this.fieldReferenceText = _.replace(this.fieldReferenceText, '{1}', '');
                        } else {
                            this.fieldReferenceText = _.replace(this.fieldReferenceText, '{1}', 's');
                        }
                    }
                });
            }

            componentSettingsMediator.getFieldTemplateComponentSettings(uiField.fieldTemplate.type, $stateParams.uiFormTemplateId).then((result) => {
                _.each(result.settings, (setting) => {
                    this.processComponentSetting(setting, uiField);

                    // Special processing needed for populating drop down setting values with static data sets
                    if ((setting.inputType === inputType.DROP_DOWN || setting.inputType === inputType.MULTI_SELECT_SET) && !_.isNil(setting.dataSetNameFromSetting)) {
                        if (!_.has(this.settingsNeedingDataSets, setting.dataSetNameFromSetting)) {
                            this.settingsNeedingDataSets[setting.dataSetNameFromSetting] = [];
                        }

                        this.settingsNeedingDataSets[setting.dataSetNameFromSetting].push(setting.settingName);
                    }

                    // Build a mapping of settingName -> setting that has a display condition dependent on that setting name
                    // This will be used later when triggering these display conditions efficiently.
                    this.buildDisplayConditionsMapping(setting);

                    // Push each setting into their appropriate option group:
                    this.addToOptionGroup(setting);
                });

                this.processDataSetSettings(this.settings).then(() => {
                    this.setIsActiveForAllSettings();
                    this.restoreDefaultValueForInactiveSettings();
                    this.evaluateOptionGroupVisibilities();
                });

            }).finally(() => {
                this.isLoading = false;
            });
        };

        this.setIsActiveForAllSettings = function () {
            _.forOwn(this.settings, (setting) => {
                setting.isActive = this.isSettingActive(setting);
            });
        };

        this.restoreDefaultValueForInactiveSettings = function () {
            _.forOwn(this.settings, (setting) => {
                const suppressFormEvents = true;

                if (!setting.isActive &&
                    setting.inputType !== inputType.BUTTON &&
                    setting.value !== setting.defaultValue) {

                    setting.value = setting.defaultValue;

                    const skipUpdateSettingObject = this.shouldSkipUpdateSettingObject(setting);

                    this.processOptionGroupInputValueChange({
                        name: setting.settingName,
                        value: setting.defaultValue
                    }, suppressFormEvents, skipUpdateSettingObject);
                }
            });
        };

        this.shouldSkipUpdateSettingObject = function (settingToCheck) {
            let skipUpdateSettingObject = false,
                propertyName = settingToCheck.propertyName;

            if (!settingToCheck.isActive) {
                if (!_.isNil(settingToCheck.xmlSubProperty)) {
                    propertyName += '.' + settingToCheck.xmlRootNodeName + '.' + settingToCheck.xmlSubProperty;
                }

                _.each(this.owningClassPropertyNameMap[settingToCheck.owningClass][propertyName], function (setting) {
                    if (settingToCheck.settingName !== setting.settingName) {
                        if (setting.isActive) {
                            skipUpdateSettingObject = true;
                            return false;
                        }
                    }
                });
            }

            return skipUpdateSettingObject;
        };

        this.processComponentSetting = function (setting, uiField) {
            const formStructure = formViewerModel.getFormStructure($stateParams.uiFormTemplateId);

            let fullSettingPropertyName = setting.propertyName;

            if (!_.isNil(setting.xmlSubProperty)) {
                fullSettingPropertyName += '.' + setting.xmlRootNodeName + '.' + setting.xmlSubProperty;
            }

            this.settings[setting.settingName] = setting;
            if (_.isEmpty(this.owningClassPropertyNameMap[setting.owningClass][fullSettingPropertyName])) {
                this.owningClassPropertyNameMap[setting.owningClass][fullSettingPropertyName] = [];
            }
            this.owningClassPropertyNameMap[setting.owningClass][fullSettingPropertyName].push(setting);

            setting.value = this.getSettingValue(setting, uiField);
            setting.disabled = !this.userCanManageForms || (setting.disabledWhenInProduction && formStructure.uiFormTemplate.formTemplate.status === formTemplateStatus.IN_PRODUCTION);
            if( setting.disabled && setting.settingName !== 'requiredFieldLevel' ) {
                setting.disabled = setting.disabled && uiField.id !== -1;
            }
            if (setting.inputType === inputType.CHECK_BOX) {
                setting.defaultValue = setting.defaultValue === 'true';
            } else {
                setting.defaultValue = _.isNil(setting.defaultValue) ? '' : setting.defaultValue;
            }

            const dynamicValues = this.getDynamicValues(setting, formStructure.uiFormTemplate.formTemplate.type);

            if (setting.settingName === 'summaryColumns') {
                this.initFieldOptions(setting);
            }

            if (!_.isNil(dynamicValues)) {
                setting.defaultValue = _.first(_.values(dynamicValues['Default']));
                setting.values = dynamicValues[setting.settingName];
            }
        };

        this.buildDisplayConditionsMapping = function (setting) {
            if (!_.isEmpty(setting.displayConditions)) {
                _.each(setting.displayConditions, (displayCondition) => {
                    const otherSetting = this.settings[displayCondition.componentSettingName];

                    // Make sure the display condition value is the correct type.
                    if (otherSetting.inputType === inputType.CHECK_BOX) {
                        displayCondition.value = displayCondition.value === 'true' || displayCondition.value === true;
                    }

                    if (!_.has(this.displayConditionsSettings, displayCondition.componentSettingName)) {
                        this.displayConditionsSettings[displayCondition.componentSettingName] = [];
                    }

                    this.displayConditionsSettings[displayCondition.componentSettingName].push(setting.settingName);
                });
            }
        };

        this.addToOptionGroup = function (setting) {
            switch (componentSettingsUtil.getOptionGroup(setting.settingName)) {
                case componentSettingsConstant.optionGroups.CORE_SETTINGS:
                    this.coreSettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.DISPLAY_SETTINGS:
                    this.displaySettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.VISIBILITY_SETTINGS:
                    this.visibilitySettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.EDITABILITY_SETTINGS:
                    this.editabilitySettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.REQUIRED_SETTINGS:
                    this.requiredSettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.VALIDATION_SETTINGS:
                    this.validationSettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.VALUE_SETTINGS:
                    this.valueSettings.push(setting);
                    break;

                case componentSettingsConstant.optionGroups.COMPONENT_SPECIFIC_SETTINGS:
                    this.componentSpecificSettings.push(setting);
                    break;
            }
        };

        this.processDataSetSettings = function (settings) {
            const updatedSettings = [];
            const promises = [];

            _.each(settings, (setting) => {
                const settingNames = this.settingsNeedingDataSets[setting.settingName];

                if (!_.isEmpty(settingNames)) {
                    const dataSetName = this.settings[setting.settingName].value;

                    if (!_.isNil(dataSetName)) {

                        const promise = coreMediator.getCachedDataSetByName(dataSetName).then((dataSet) => {
                            if (dataSet && dataSet.type !== dataSetType.STATIC) {
                                this.selectedField.fieldTemplate.dynamicDataSet = false;
                            } else {
                                this.selectedField.fieldTemplate.dynamicDataSet = true;
                            }

                            _.each(settingNames, (settingName) => {
                                const setting = this.settings[settingName];
                                updatedSettings.push(setting);
                                setting.values = {};
                                _.each(dataSet.items, function (item) {
                                    setting.values[item.name] = item.value;
                                });
                            });
                        }).catch(() => {
                            _.each(settingNames, (settingName) => {
                                const setting = this.settings[settingName];

                                updatedSettings.push(setting);
                                setting.values = {};
                            });
                        });

                        promises.push(promise);
                    }
                }
            });

            const defer = $q.defer();

            $q.all(promises).finally(function () {
                defer.resolve(updatedSettings);
            });

            return defer.promise;
        };

        this.getSettingObject = function (owningClass, uiField) {
            let settingObject = null;

            switch (owningClass) {
                case fieldTemplateComponentSettingOwningClass.FIELD_TEMPLATE:
                    settingObject = uiField.fieldTemplate;
                    break;

                case fieldTemplateComponentSettingOwningClass.UI_FIELD:
                    settingObject = uiField;
                    break;
            }

            return settingObject;
        };

        this.initFieldOptions = function (setting) {
            const uiFieldOptions = this.selectedField['options'];
            const xmlObject = xmlUtil.parseStringWithoutFlattening(uiFieldOptions)['options'];
            const formTemplateName = _.get(xmlObject, 'formRepeaterSummary.formTemplateName');

            configurationMediator.getFieldOptions(formTemplateName).then(function (fieldOptions) {
                setting.values = {};
                setting.fieldOptions = fieldOptions;
                _.each(fieldOptions, function (fieldOption) {
                    setting.values[fieldOption.fieldName] = fieldOption.fieldName;
                });
            });
        };

        this.getSettingObjectValue = function (propertyName, settingName, xmlRootNodeName, xmlSubProperty, settingObject, type) {
            let settingValue = null;

            if (!_.isNil(xmlSubProperty)) {
                const xmlSettings = xmlUtil.parseStringWithoutFlattening(settingObject[propertyName])[xmlRootNodeName];
                _.forOwn(xmlSettings, function (value, key) {
                    const option = xmlUtil.parseString(value);
                    if (!_.isEmpty(option)) {
                        xmlSettings[key] = option;
                    }
                });

                settingValue = _.get(xmlSettings, xmlSubProperty);
                if (settingName === 'summaryColumns') {
                    if (!_.isArray(settingValue)) {
                        settingValue = settingValue._variableName;
                    } else {
                        const summaryColumnJoinedValue = _.join(_.map(settingValue, '_variableName'));
                        settingValue = summaryColumnJoinedValue;
                    }
                }
            } else {
                settingValue = this.getSettingObjectValueFromPropertyName(propertyName, settingObject);
            }

            return type === inputType.CHECK_BOX ? (settingValue === 'true' || settingValue === true) : !_.isNil(settingValue) ? settingValue.toString() : null;
        };

        this.getSettingObjectValueFromPropertyName = function (propertyName, settingObject) {
            // Split apart (OR) concatenations in the property name
            const propertyNameOrSplits = _.split(propertyName, '||');

            let settingValue = null;

            _.each(propertyNameOrSplits, function (orPropName) {
                // Split apart property names (max 2) and concatenate them back with the proper values
                const propertyNameConcatSplits = _.split(orPropName, '::');
                if (_.size(propertyNameConcatSplits) === 2) {
                    const property0Value = settingObject[propertyNameConcatSplits[0]];
                    const property1Value = settingObject[propertyNameConcatSplits[1]];

                    if (!_.isNil(property0Value) && !_.isNil(property1Value) && !_.isEmpty(property0Value) && !_.isEmpty(property1Value)) {
                        settingValue = property0Value + '::' + property1Value;
                    }
                } else {
                    settingValue = settingObject[propertyNameConcatSplits[0]];
                }

                // If the setting value exists, we can return, without looking at other parts of the (OR) property name
                if (!_.isEmpty(settingValue)) {
                    return false;
                }
            });

            return settingValue;
        };

        this.getSettingValue = function (setting, uiField) {
            const settingObject = this.getSettingObject(setting.owningClass, uiField);
            const settingValue = this.getSettingObjectValue(setting.propertyName, setting.settingName, setting.xmlRootNodeName, setting.xmlSubProperty, settingObject, setting.inputType);

            return settingValue;
        };

        this.getDynamicValues = function (setting, formTemplateType) {
            let dynamicValues = null;

            if (!_.isNil(setting.dynamicValuesFormTypeDependent)) {
                dynamicValues = setting.dynamicValuesFormTypeDependent[formTemplateType];
            }

            return dynamicValues;
        };

        this.isSettingActive = function (setting) {
            const displayConditions = setting.displayConditions;

            let isSettingActive = false;

            _.each(displayConditions, (displayCondition) => {
                const otherSetting = this.settings[displayCondition.componentSettingName];
                const operator = displayCondition.operator;
                const value = displayCondition.value;

                if (!_.isNil(otherSetting)) {
                    isSettingActive = false;
                    switch (operator) {
                        case displayConditionOperator.EQUALS:
                            if (otherSetting.value === value) {
                                isSettingActive = true;
                            }
                            break;

                        case displayConditionOperator.NOT_EQUALS:
                            if (otherSetting.value !== value) {
                                isSettingActive = true;
                            }
                            break;

                        case displayConditionOperator.NOT_EMPTY:
                            if (!_.isEmpty(otherSetting.value)) {
                                isSettingActive = true;
                            }
                            break;

                        case displayConditionOperator.EMPTY_VALUE_SET:
                            if (_.isEmpty(otherSetting.values)) {
                                isSettingActive = true;
                            }
                            break;

                        case displayConditionOperator.NOT_EMPTY_VALUE_SET:
                            if (!_.isEmpty(otherSetting.values)) {
                                isSettingActive = true;
                            }
                            break;
                    }

                    // If comparing using AND, stop looping through conditions if ANY evaluate to FALSE,
                    // otherwise OR is used, and stop looping if any evaluate to TRUE
                    if ((setting.displayConditionComparisonOperator === displayConditionLogicalOperator.AND && !isSettingActive)
                        || (setting.displayConditionComparisonOperator !== displayConditionLogicalOperator.AND && isSettingActive)) {
                        return false;
                    }
                }
            });

            return isSettingActive || _.isEmpty(displayConditions);
        };

        this.evaluateDisplayConditions = function (nameOfSetting, parentIsActive) {
            _.each(this.displayConditionsSettings[nameOfSetting], (settingName) => {
                const setting = this.settings[settingName];
                const wasActive = setting.isActive;
                const suppressFormEvents = true;

                setting.isActive = parentIsActive && this.isSettingActive(setting);

                // If the setting was not active before, and is now active, or vice versa, we should update its value to its default value (excluding buttons)
                if (setting.inputType !== inputType.BUTTON && ((!wasActive && setting.isActive) || (wasActive && !setting.isActive))) {

                    setting.value = setting.defaultValue;
                    this.processOptionGroupInputValueChange({
                        name: setting.settingName,
                        value: setting.defaultValue
                    }, suppressFormEvents);

                    if (setting.settingName === 'summaryColumns') {
                        this.initFieldOptions(setting);
                    }
                }

                // Avoid infinite recursion on self referential conditions
                if (nameOfSetting !== settingName) {
                    this.evaluateDisplayConditions(settingName, setting.isActive);
                }
            });
        };

        this.evaluateOptionGroupVisibilities = function () {
            this.showCoreSettings = this.showOptionGroup(this.coreSettings);
            this.showDisplaySettings = this.showOptionGroup(this.displaySettings);
            this.showEditabilitySettings = this.showOptionGroup(this.editabilitySettings);
            this.showVisibilitySettings = this.showOptionGroup(this.visibilitySettings);
            this.showRequiredSettings = this.showOptionGroup(this.requiredSettings);
            this.showValueSettings = this.showOptionGroup(this.valueSettings);
            this.showValidationSettings = this.showOptionGroup(this.validationSettings);
            this.showComponentSpecificSettings = this.showOptionGroup(this.componentSpecificSettings);
        };

        this.showOptionGroup = function (settings) {
            let showOptionGroup = false;

            _.each(settings, function (setting) {
                if (setting.isActive) {
                    showOptionGroup = true;
                    return false;
                }
            });

            return showOptionGroup;
        };

        this.openFieldReferencePopup = function () {
            const fieldTemplateId = this.selectedField.fieldTemplate.id;
            const variableName = this.selectedField.fieldTemplate.variableName;

            return configurationMediator.getFieldReferences(fieldTemplateId).then(function (fieldTemplateReferences) {
                return modalUtil.openFieldReferencesModal('fieldReferences', fieldTemplateReferences, variableName);
            });
        };

        this.processSummaryColumns = function (setting, settingObject, xmlObject) {
            const oldColumns = _.get(xmlObject, setting.xmlRootNodeName + '.' + setting.xmlSubProperty);
            const pickedColumns = _.split(setting.value, setting.valueDelimiter);
            const addedColumns = [];
            const removedColumns = [];

            _.each(pickedColumns, function (pickedColumn) {
                const existingColumn = _.find(oldColumns, {'_variableName': pickedColumn});
                if (!existingColumn) {
                    addedColumns.push(pickedColumn);
                }
            });

            _.each(oldColumns, function (oldColumn) {
                if (!_.includes(pickedColumns, oldColumn._variableName)) {
                    removedColumns.push(oldColumn);
                }
            });

            const newColumns = _.differenceBy(oldColumns, removedColumns, '_variableName');

            _.each(addedColumns, function (addedColumn) {
                const fieldOption = _.find(setting.fieldOptions, {'fieldName': addedColumn});
                if (!_.isNil(fieldOption)) {
                    newColumns.push({
                        _columnHeading: fieldOption.displayLabel,
                        _variableName: addedColumn,
                        _width: fieldOption.width ? fieldOption.width : 150
                    });
                }
            });

            // Special case with a new (empty) grid or grid with all columns removed
            if (_.isEmpty(newColumns)) {
                newColumns.push({
                    _columnHeading: '',
                    _variableName: '',
                    _width: 150
                });
            }

            _.set(xmlObject, setting.xmlRootNodeName + '.' + setting.xmlSubProperty, newColumns);

            return xmlObject;
        };

        this.processOptionGroupInputValueChange = function (optionGroupInput, suppressFormEvents, skipUpdateSettingObject) {
            const setting = this.settings[optionGroupInput.name];

            if (setting.inputType === inputType.NUMBER) {
                optionGroupInput.value = parseFloat(optionGroupInput.value);
            }

            setting.value = optionGroupInput.value;
            if (!skipUpdateSettingObject) {
                const settingObject = this.getSettingObject(setting.owningClass, this.selectedField);

                const isXmlSubProperty = !_.isNil(setting.xmlSubProperty);
                if (isXmlSubProperty) {
                    let xmlObject = {};
                    // We must properly parse the existing xml values, update the appropriate value and push the
                    // updated xml string onto the object.
                    xmlObject[setting.xmlRootNodeName] = {}; // Root the object with the xmlRootNodeName
                    xmlObject[setting.xmlRootNodeName] = xmlUtil.parseStringWithoutFlattening(settingObject[setting.propertyName])[setting.xmlRootNodeName];
                    if (_.isNil(xmlObject[setting.xmlRootNodeName])) {
                        xmlObject[setting.xmlRootNodeName] = {};
                    }
                    if (setting.settingName === 'summaryColumns') {
                        xmlObject = this.processSummaryColumns(setting, settingObject, xmlObject);
                    } else {
                        _.set(xmlObject, setting.xmlRootNodeName + '.' + setting.xmlSubProperty, setting.value);
                    }
                    settingObject[setting.propertyName] = xmlUtil.toXmlString(xmlObject);
                } else {
                    if (setting.settingName === 'linkTo') {
                        const propertyNameOrSplits = _.split(setting.propertyName, '||');
                        const propertyNameConcatSplits = _.split(propertyNameOrSplits[0], '::');
                        if (_.includes(setting.value, '::')) {
                            const settingValueSplits = _.split(setting.value, '::');
                            settingObject[propertyNameConcatSplits[0]] = settingValueSplits[0];
                            settingObject[propertyNameConcatSplits[1]] = settingValueSplits[1];

                            settingObject[propertyNameOrSplits[1]] = null;
                        } else {
                            settingObject[propertyNameOrSplits[1]] = setting.value;

                            settingObject[propertyNameConcatSplits[0]] = null;
                            settingObject[propertyNameConcatSplits[1]] = null;
                        }
                    } else {
                        settingObject[setting.propertyName] = setting.value;
                    }
                }
            }

            this.processDataSetSettings([setting]).then((updatedSettings) => {
                _.each(updatedSettings, (updatedSetting) => {
                    this.evaluateDisplayConditions(updatedSetting.settingName, /*parentIsActive*/true);
                });
            });

            this.evaluateDisplayConditions(optionGroupInput.name, /*parentIsActive*/true);

            this.evaluateOptionGroupVisibilities();

            formMediator.updateFieldStructureConfiguration(this.selectedFieldStructure, suppressFormEvents);
        };

        $scope.$on(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, (event, optionGroupInput) => {
            this.processOptionGroupInputValueChange(optionGroupInput);
        });

        this.$onChanges = function (changes) {
            const isRowRepeater = this.selectedFieldStructure.repeating;
            const selectedFieldExists = !_.isNil(changes.selectedField);
            const currentValueExists = !_.isNil(changes.selectedField.currentValue);

            let currentStructureId = null,
                previousStructureId = null;

            if (isRowRepeater) {
                currentStructureId = _.get(changes, 'selectedFieldStructure.currentValue.rowStructureId');
                previousStructureId = _.get(changes, 'selectedFieldStructure.previousValue.rowStructureId');
            }
            else {
                currentStructureId = _.get(changes, 'selectedFieldStructure.currentValue.fieldStructureId');
                previousStructureId = _.get(changes, 'selectedFieldStructure.previousValue.fieldStructureId');
            }

            if ((selectedFieldExists && currentValueExists) && currentStructureId !== previousStructureId) {
                this.init(this.selectedField);
            }
        };

        this.init(this.selectedField);
    });
};

angular.module('ums.configuration')
    .controller('componentSettingsController', ComponentSettingsController);
